import React, { useState } from 'react';
import '../scss/loyalty-promotion-banner.component.scss';
import { useTranslation } from 'react-i18next';

const images = [
    '/assets/png/banner-01.png',
    '/assets/png/banner-02.png',
    '/assets/png/banner-03.png'
];
const imagesSwedish = [
    '/assets/png/swedish-banner-01.png',
    '/assets/png/swedish-banner-02.png',
    '/assets/png/swedish-banner-03.png'
];

const LoyaltyPromotionBanner: React.FC = () => {
    const [index, setIndex] = useState(0);
    const { i18n } = useTranslation();

    const currentLanguage = i18n.language;

    const imagesToShow = currentLanguage === 'sv-se' ? imagesSwedish : images;

    return (
        <div className="loyalty-promotion-banner carousel">
            <div className="slides" style={{ transform: `translateX(-${index * 100}%)` }}>
                {imagesToShow.map((src, i) => (
                    <div className="slide" key={i}>
                        <img src={src} alt="Loyalty promotion" className="loyalty-promotion-image" />
                    </div>
                ))}
            </div>
            <div className="carousel-dots">
                {imagesToShow.map((_, i) => (
                    <button
                        key={i}
                        className={`dot${i === index ? ' active' : ''}`}
                        aria-label={`Go to slide ${i + 1}`}
                        onClick={() => setIndex(i)}
                    />
                ))}
            </div>
        </div>
    );
};

export default LoyaltyPromotionBanner;
